// extracted by mini-css-extract-plugin
module.exports = {"card":"WalletCard_card__1tTE1","value":"WalletCard_value__3Cslk","title":"WalletCard_title___mNCJ"};